import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { Tournament, TournamentDetails } from './types';


export const tournamentsApi = createApi({
  reducerPath: 'tournamentsApi',
  baseQuery: fetchBaseQuery({ baseUrl: '/api/v1/tournaments/' }),
  endpoints: (builder) => ({
    getTournaments: builder.query<Tournament[], string>({
      query: () => '',
      transformResponse: (response: { data: { items: Tournament[] } }) => response.data.items,
    }),
    getTournamentById: builder.query<TournamentDetails, string>({
      query: (id: string) => `${id}/`,
      transformResponse: (response: { data: TournamentDetails }) => response.data,
    }),
  }),
});

export const {
  useGetTournamentsQuery,
  useGetTournamentByIdQuery
} = tournamentsApi;
